import React from 'react';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import IntegrationsImageAndContent from 'src/app/organisms/Homepage/IntegrationsImageAndContent/IntegrationsImageAndContent';
import IntegrationCards from 'src/app/organisms/Homepage/IntegrationCards/IntegrationCards';
import SectionLayout from 'src/app/atoms/Layout/Section/SectionLayout';

const Integrations = (): JSX.Element => {
  return (
    <SectionLayout
      maxWidth='width-3xl'
      padding={['spacing-7xl', 'spacing-none']}
      paddingSm={['spacing-4xl', 'spacing-none']}
    >
      <Stack
        direction='column'
        align='center'
        gap='spacing-7xl'
        gapLg='spacing-4xl'
        padding={['spacing-none', 'spacing-4xl']}
        paddingSm={['spacing-none', 'spacing-xl']}
      >
        <IntegrationsImageAndContent />
        <IntegrationCards />
      </Stack>
    </SectionLayout>
  );
};

export default Integrations;
